export const CheckingAccountNumberFieldData = {
  formControlName: 'checkingAccountNumber',
  id: 'grit-field-checking-account-number',
  type: 'tel',
  visibilityCanToggle: true,
  hint:
    'This is the second set of numbers at the bottom of your checks (right side).',
  label: 'Checking account number',
  prefixIcon: {
    iconName: 'security',
  },
  requiredMessage:
    'Your checking account number is required to process the application.',
  validCharacters: '0123456789',
};
